module.exports = __webpack_public_path__ + "img/ad_2.c66c60f4.png";